import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=0882c782&scoped=true"
import script from "./Secret.vue?vue&type=script&lang=js"
export * from "./Secret.vue?vue&type=script&lang=js"
import style0 from "./Secret.vue?vue&type=style&index=0&id=0882c782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882c782",
  null
  
)

export default component.exports